import './text-box.scss'
import { CmsLinkComponent } from '@omnia/ui/src/lib/cms/components/cmsLink/CmsLink'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import type { TextBoxPropsApi } from '@/features/grid/textBoxes/models'

export const TextBoxes: FC<GridElement<TextBoxPropsApi[]>> = props => {
    const { value: textBoxes = [] } = props
    return (
        <div className="text-boxes">
            {textBoxes.map((box, index) => (
                <div className="text-box" key={index}>
                    {box.tagline && <h3 className="text-box__tagline">{box.tagline}</h3>}
                    <h2 className="text-box__heading">{box.heading}</h2>
                    <p className="text-box__text">{box.content}</p>
                    <div className="text-box__buttons">
                        {box.buttonLink && <CtaButton link={box.buttonLink} />}
                        {box.ctaLink && <CmsLinkComponent className="text-box__buttons__cta-link" link={box.ctaLink} />}
                    </div>
                </div>
            ))}
        </div>
    )
}
